import type { ReactNode } from 'react'

export type SegmentedOption<T extends string> = { value: T; label: ReactNode; description?: ReactNode }

export const Segmented = <T extends string>({
  label,
  name,
  value,
  options,
  onChange,
  hint,
  layout = 'wrap',
}: {
  label: string
  name: string
  value: T
  options: readonly SegmentedOption<T>[]
  onChange: (value: T) => void
  hint?: ReactNode
  layout?: 'wrap' | 'grid'
}) => (
  <fieldset className="segmented">
    <legend className="segmented-legend">{label}</legend>
    {hint === undefined ? null : <p className="segmented-hint">{hint}</p>}
    <div className={layout === 'grid' ? 'segmented-options segmented-grid' : 'segmented-options'}>
      {options.map((option) => (
        <label key={option.value} className="segmented-option">
          <input
            className="visually-hidden"
            type="radio"
            name={name}
            value={option.value}
            checked={option.value === value}
            onChange={() => onChange(option.value)}
          />
          <span className="segmented-label">{option.label}</span>
          {option.description === undefined ? null : (
            <span className="segmented-description">{option.description}</span>
          )}
        </label>
      ))}
    </div>
  </fieldset>
)
